import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import {
    userSearchResultCrmIdsDataSelector,
    userSearchResultCrmIdsResultSelector,
} from '../../slices/user-search-result-crm-ids.slice';

type Props = {
    userId: number,
};

export const MsDynamicsIdCell = ({userId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultCrmIdsDataSelector);
    const result = useSelector(userSearchResultCrmIdsResultSelector);

    const msDynamicsId = useMemo(
        () => result?.data[userId]?.MSDynId,
        [result, userId],
    );

    if (isLoading || loadingError || !msDynamicsId) {
        return null;
    }

    return (
        <EllipsisTextHint title={msDynamicsId}>{msDynamicsId}</EllipsisTextHint>
    );
};
